module.exports = __webpack_public_path__ + "media/directory/forum_icon-d89423cc.svg";